import axios from "axios";

export default {
  namespaced: true,
  state: {
    roles: [],
    images: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    rolesMessage: ''
  },
  mutations: {
    RECEIVED_ROLES(state, payload) {
      state.roles = payload;
      state.isReceiving = false;
    },
    RECEIVING_ROLES(state) {
      state.isReceiving = true;
    },
    RECEIVED_ROLE(state, payload) {
      state = Object.assign(state, {
        roles: [...state.roles, payload],
        isReceiving: false,
      })
    },
    RECEIVING_ROLE(state) {
      state.isReceiving = true;
    },
    UPDATE_ROLE_SUCCESS(state, payload) {
      let index = state.roles.findIndex(role => role._id === payload._id);
      state = Object.assign(state, {
        roles: state.roles.map((role, i) => {
          if (i === index) {
            return Object.assign({}, role, payload);
          }
          return role;
        }),
        isUpdating: false,
        rolesMessage: 'Roles has been updating!',
      })
    },
    UPDATING_ROLE(state) {
      state.isUpdating = true;
    },
    DELETE_ROLE_SUCCESS(state, payload) {
      let indexToDelete = state.roles.findIndex(role => role._id === payload._id);
      let roles = [...state.roles];
      roles.splice(indexToDelete, 1);
      state = Object.assign(state, {
        roles: [...roles],
        isDeleting: false,
        idToDelete: null,
        rolesMessage: 'Role has been Deleted!',
      });
    },
    DELETING_ROLE(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    async copyRoleRequest({dispatch}, payload) {
      dispatch("receivingRole");
      let  token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/copy/role/' + payload._id;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      return axios({method: "post", url: url, headers: headers})
      .then((response)=> {
        dispatch("receiveRole", response.data);
      })
      .catch((error) => {
        this.alertmessage = error.response.data.error;
      });	
    },
    getRolesRequest({dispatch}) {
      dispatch("receivingRoles");
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/get/roles';
      let header = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      axios({method: "get", url: url,headers: header})
      .then(response => {
        dispatch("receiveRoles", response.data);
      })
    },
    async getRoleRequest(roleid) {
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/get/role/'+roleid;
      let header = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};
      let get = {method: "get", url: url, headers: header};
      let response = await axios(get);
      return response.data;
    },
    insertRole({dispatch}, payload) {
      dispatch("receivingRoles");
      var url;
      var data;
      var header;
      var token = localStorage.getItem('token');
      url = 'https://api.tradexc.com:3000/insert/role';
      data = payload;
      header = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      };
      
      var post = {
        method: "post",
        url: url,
        headers: header,
        data: data,
      };
      axios(post)
      .then(function (response) {
        dispatch("receiveRole", response.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });	
    },
    async updateRoleRequest({dispatch}, payload) {
      dispatch("updatingRole");
      let id = payload._id;
      delete payload['_id'];
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/update/role/' + id;
      let header = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};

      return axios({method: "put",url: url,headers: header,data: payload})
      .then(function (res) {
        dispatch("updateRoleSuccess", res.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });
    },
    deleteRoleRequest({dispatch}, payload) {
      dispatch("deletingRole", payload);
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/delete/role/' + payload._id
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      axios({method: "DELETE", url: url, headers: headers}).then((response) => {
        dispatch("deleteRole", response.data);
      })
    },
    receiveRoles({commit}, payload) {
      commit("RECEIVED_ROLES", payload)
    },
    receivingRoles({commit}) {
      commit("RECEIVING_ROLES")
    },
    receiveRole({commit}, payload) {
      commit("RECEIVED_ROLE", payload)
    },
    receivingRole({commit}) {
      commit("RECEIVING_ROLE")
    },
    updateRoleSuccess({commit}, payload) {
      commit("UPDATE_ROLE_SUCCESS", payload)
    },
    updatingRole({commit}) {
      commit("UPDATING_ROLE")
    },
    deleteRole({commit}, payload) {
      commit("DELETE_ROLE_SUCCESS", payload)
    },
    deletingRole({commit}, payload) {
      commit("DELETING_ROLE", payload)
    }
  },
};
